export enum HeaderVariant {
  WELCOME,
  GO_BACK,
  EDITOR,
}
